import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

export interface AppNavigation {
  /** Empilha uma rota (push) — mantém a anterior no histórico, permite voltar. */
  goTo(path: string): void;
  /**
   * Substitui a rota atual — não deixa a anterior no histórico. O `state` é o recado da tela
   * que navega para a tela de destino (`loginHandoffOf`), fora da URL.
   */
  replace(path: string, state?: unknown): void;
  /** Volta uma entrada no histórico. */
  back(): void;
}

/**
 * Navegação imperativa do app atrás de uma interface própria. As páginas chamam isto
 * em vez de `useHistory` direto, então trocar o router no futuro (o `@ionic/react-router`
 * prende no react-router v5) reescreve só este hook, não as telas.
 */
export function useAppNavigation(): AppNavigation {
  const history = useHistory();
  return useMemo(
    () => ({
      goTo: (path: string) => history.push(path),
      replace: (path: string, state?: unknown) => history.replace(path, state),
      back: () => history.goBack(),
    }),
    [history],
  );
}
